<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
  <path stroke="#000" d="M8.5 20.496l7.5-7.5-7.5-7.5"/>
</svg>
